export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3 tracking-tight">
            关于今日看料
          </h2>
          <p className="text-foreground-500 text-sm text-center mb-8">美好生活从今日开始</p>
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
              今日看料成立于2020年，是国内领先的综合资讯聚合平台。我们致力于为用户提供高质量、多元化的内容服务，涵盖社会热点、娱乐八卦、生活百科、科技数码等多个领域。平台以"美好生活从今日开始"为核心理念，每天精选优质内容，帮助用户快速了解当日最值得关注的信息。我们拥有一支专业的内容运营团队，坚持人工筛选与智能推荐相结合，确保每一条内容都经过严格把关。截至目前，平台已累计服务超过千万用户，日均内容更新量超过200条，成为越来越多用户每日必访的信息入口。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}